import { ApplicationElement, html } from '../application_element/element.js';
import Attachment from '../attachment/element.js';
import style from './style.lit.css';

/**
 * Uploaded file with image or icon
 *
 * @prop file - File name
 * @prop tags - Tag color and name on top of the component ( array, optional )
 * @prop maxTagsCount - Max tags count that can be displayed ( number, default: 6, optional )
 * @prop imgSrc - Image url ( string, optional )
 * @prop imgWidth - Image width ( number, optional )
 * @prop imgHeight - Image height ( number, optional )
 * @prop size - File size ( string, optional )
 */
export default class File extends Attachment {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    tags: { type: Array },
    imgSrc: { type: String },
    imgWidth: { type: Number },
    imgHeight: { type: Number },
  };

  constructor() {
    super();
    this.maxTagsCount = 6;
  }

  get name() {
    return `${super.name}.${this.ext}`;
  }

  get imgSize() {
    if (!this.imgWidth && !this.imgHeight) {
      return null;
    }
    return `(${this.imgWidth}x${this.imgHeight})`;
  }

  renderTags() {
    if (!this.tags) {
      return null;
    }

    const withName = this.tags.length === 1;

    return html`
      <div class="tags">
        ${this.tags
          .slice(0, this.maxTagsCount)
          .map(tag => this.renderTag(tag, withName))}
      </div>
    `;
  }

  renderTag(tag, withName) {
    return html`
      <span
        class="tag tag-v${withName ? '3' : '4'} t2 color-${tag.color}"
        title=${tag.name}>
        ${withName ? tag.name : ''}
      </span>
    `;
  }

  renderFigure() {
    return html`
      <figure class="image">
        ${this.imgSrc
          ? html` <img loading="lazy" class="img" src=${this.imgSrc} />`
          : this.renderIcon()}
      </figure>
    `;
  }

  renderInfo() {
    return html`
      <div class="info">
        <div class="title">
          ${this.splitedName.map(item => html`<span>${item}</span>`)}
        </div>
        ${(this.size || this.imgSize) &&
        html` <div class="size">
          ${this.size}
          ${this.imgSize &&
          html`<span class="attachment-dimensions">${this.imgSize}</span>`}
        </div>`}
      </div>
    `;
  }

  render() {
    return html`
      ${this.renderTags()} ${this.renderFigure()} ${this.renderInfo()}
    `;
  }
}

customElements.get('ef-file') || customElements.define('ef-file', File);
